import React, { memo, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';

import { useTimer } from '@wwe-portal/web/hooks/web-coin/useTimer.hook';

import { msToTime } from '@wwe-portal/web/utils/timing/msToTime.util';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';

/**
 * Use Timer custom hook
 * timestamp for leaderboard refresh
 */
const dateNow = new Date().toString();

function RefreshTimer({
  handleTimerFromChild = () => {},
  time = dateNow,
  hasIcon = true,
}) {
  /**
   * Use Timer custom hook
   * timestamp for leaderboard refresh
   */

  const timeProp = time ? new Date(time) : new Date(dateNow);

  const timer = useTimer(
    (24 -
      timeProp.getHours() -
      timeProp.getMinutes() / 60 -
      timeProp.getSeconds() / 60 / 60) *
      60 *
      60 *
      1000
  );

  /**
   * Use translation hook
   * @see https://react.i18next.com/
   */
  // const [t] = useTranslation();

  useEffect(() => {
    if (Math.round(timer) === 0) {
      handleTimerFromChild();
    }
    // eslint-disable-next-line
  }, [timer]);

  return (
    <div data-id="refresh-timer" className="flex items-center">
      {hasIcon && (
        <IcoMoonIcon iconName="timer" className="text-text700 size-4" />
      )}
      {timer <= 0 ? (
        // Refresh leaderboard store
        <span />
      ) : (
        <span className="text-text500 min-w-[75px]">{msToTime(timer)}</span>
      )}
    </div>
  );
}

export default memo(RefreshTimer);
